<!--
  In order to autocomplete fields in Chrome need, certain name attributes for input tags need to be set. See
  https://source.chromium.org/chromium/chromium/src/+/master:components/autofill/core/common/autofill_regex_constants.cc
  for the Regex details
-->

<template>
  <div>
    <div class="form-group">
      <h4 class="mt-2">Bank account holder</h4>
      <div class="row">
        <div class="col-md-4" :class="{'has-success': bankNameValid, 'has-error': !bankNamePotentiallyValid}">
          Account name<br/>
          <input type="text" class="form-control" v-model="form_data.name">
          <small v-if="!bankNameValid" class="text-danger">Please enter the name on the bank account</small>
        </div>
        <div class="col-md-4" :class="{'has-success': bankRoutingValid, 'has-error': !bankRoutingPotentiallyValid }">
          Routing number<br />
          <input type="text" class="form-control" placeholder="123456789"  v-model="form_data.routing">
          <small v-if="!bankRoutingValid" class="text-danger">Please enter a valid routing number</small>
        </div>
        <div class="col-md-4"  :class="{ 'has-success': bankAccountValid, 'has-error': !bankAccountPotentiallyValid }">
            Account number<br />
            <input type="text" class="form-control" v-model="form_data.account">
            <small v-if="!bankAccountValid" class="text-danger">Please enter a valid account number</small>
        </div>
      </div>
      <br/>
      <div class="row">
        <div class="col-md-3">
          Account type
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label class="radio-head" id="ach-check">
            <input type="radio" name="ach-type" :value="checking" v-model="form_data.account_type">
            <span>Checking</span>
          </label>
          <label class="radio-head" id="ach-savings">
            <input type="radio" name="ach-type" :value="savings" v-model="form_data.account_type">
            <span>Savings</span>
          </label>
        </div>
      </div>
      <div class="row" v-if="!bankAccountTypeValid">
        <div class="col-md-6">
          <small class="text-danger">Please select an account type</small>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <p :class="[hasDarkTheme ? 'bg-info' : 'bg-warning']" style="padding:10px 15px; margin-top:10px">
          <b>Please double-check</b> that the account info entered above is correct. <br />Incorrect information will result in a bounced payment fee of $20.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { BFormInput } from 'bootstrap-vue';
  import { mapGetters } from 'vuex';
  const bankValid = require('us-bank-account-validator');

  export default {
    emits: ['form-invalid', 'form-state', 'form-valid', 'input'],
    props: {
      // helpful for pre-filling data
      accountName: {
        required: false,
        type: String,
        default: ''
      },
    },


    data () {
      return {
        checking: 'CHECKING',
        savings: 'SAVINGS',
        extra_routing_numbers: [
          '124003284', '031101334' // sofi routing numbers
        ],
        form_data: {
          name: this.accountName.trim(),
          routing: '',
          account: '',
          account_type: ''
        },
      }
    },

    computed: {
      bankNameValid () {
        if (this.form_data.name === '') { return false }
        return /^[a-z A-Z]+$/.test(this.form_data.name);
      },
      bankNamePotentiallyValid () {
        if (this.form_data.name === '') { return true }
        return /^[a-z A-Z]+$/.test(this.form_data.name);
      },
      bankRoutingValid () {
        let routingNum = this.form_data.routing
        return Boolean(bankValid.routingNumber(routingNum).isValid | this.extra_routing_numbers.includes(routingNum))
      },
      bankRoutingPotentiallyValid () {
        let validation = bankValid.routingNumber(this.form_data.routing)
        return validation.isPotentiallyValid;
      },
      bankAccountValid () {
        let validation = bankValid.accountNumber(this.form_data.account)
        return validation.isValid;
      },
      bankAccountPotentiallyValid () {
        let validation = bankValid.accountNumber(this.form_data.account)
        return validation.isPotentiallyValid;
      },
      bankAccountTypeValid () {
        return [this.checking, this.savings].includes(this.form_data.account_type);
      },
      bankIsValid () {
        return !!(this.bankNameValid && this.bankRoutingValid && this.bankAccountValid);
      },
      formDataValid() {
        return this.bankIsValid && this.bankAccountTypeValid;
      },
      formData() {
        return this.form_data;
      },
      ...mapGetters([
        'hasDarkTheme'
      ])
    },

    methods: {
      resetForm() {
        this.form_data = {
          name: this.accountName.trim(),
          routing: '',
          account: '',
          account_type: ''
        };
      }
    },

    watch: {
      formData: {
        handler(new_val) {
          this.$emit('input', new_val);
        },
        deep: true
      },
      formDataValid(new_val){
        this.$emit('form-state', new_val);
        this.$emit(new_val ? 'form-valid' : 'form-invalid');
      },
    },

    components: {
      BFormInput,
    }
  }
</script>



// WEBPACK FOOTER //
// NewBankAccountForm.vue?69c4a396